import React from 'react';

export const confinementDescription = (
  <p>
    Please tell us your dates of confinement.
    <br />
    <em>The dates need to be within a single service period.</em>
  </p>
);
